import {
  PennylaneAggregationLevelEnum,
  TotalModeEnum,
} from '@e-socna/data-layer';

import type { AggregationLevelGroupInput } from './aggregation-level-group.type';

// The ServiceUsage level needs at least one Automatic group to build its
// per-usage lines (a Manual-total group becomes a single line, but nothing
// is left to list when every group is Manual) - back rejects it otherwise,
// see check-accounting-info-state-before-update.pipe.ts.
export function isServiceUsageAggregationLevelAvailable(
  groups: readonly AggregationLevelGroupInput[],
): boolean {
  return groups.some((group) => group.totalMode === TotalModeEnum.Automatic);
}

// Default level when the accounting action shows no dialog - confirmed by
// user 2026-10-02, see docs/spec/00-project-spec.md §"Total per group" ->
// "Accounting aggregation level".
export function resolveDefaultAggregationLevel(
  groups: readonly AggregationLevelGroupInput[],
): PennylaneAggregationLevelEnum {
  return isServiceUsageAggregationLevelAvailable(groups)
    ? PennylaneAggregationLevelEnum.ServiceUsage
    : PennylaneAggregationLevelEnum.Group;
}
